/**
 * Rich Text Input Header Component
 *
 * Purpose: Renders the header section of the rich text input that displays
 * contextual information such as edit previews, reply previews, and link previews.
 *
 * How it works:
 * 1. Renders EditMessagePreview when editing an existing message
 * 2. Renders ReplyMessagePreview when replying to a message
 * 3. Renders RtfLinkPreview when a link is detected in the input
 *
 * Key features:
 * - Contextual UI elements that appear only when needed
 * - Integration with message editing and reply workflows
 * - Link preview functionality
 */

import EditMessagePreview from "../../EditMessagePreview";
import ReplyMessagePreview from "../../ReplyMessagePreview";
import RtfLinkPreview from "../../RtfLinkPreview";

export default function RtfInputHeader() {
  return (
    <>
      <EditMessagePreview />
      <ReplyMessagePreview />
      <RtfLinkPreview />
    </>
  );
}
